import * as React from 'react';
import { MethodWrapper } from './MethodWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsPaymentMethodSelected } from '../../../../../selectors/paymentMethods';
import { selectPaymentMethod } from '../../../../../actions/paymentMethods';
import { decodePaymentMethodId } from '../../../../../utils/paymentMethods';
import { trackPaymentMethodClick } from '../../../../../trackers/trackPaymentMethodClick';
import { selectPackageId, selectPaymentInitSource } from '../../../../../selectors/checkout';

interface IProps {
  children: React.ReactNode;
  id: string;
}

export const MethodWrapperContainer = (props: IProps) => {
  const { id, children } = props;

  const isSelected = useSelector(selectIsPaymentMethodSelected(id));
  const paymentInitSource = useSelector(selectPaymentInitSource);
  const packageId = useSelector(selectPackageId);

  const type = React.useMemo(() => {
    const { type } = decodePaymentMethodId(id);

    return type;
  }, [id]);

  const dispatch = useDispatch();

  const handleClick = React.useCallback(() => {
    dispatch(selectPaymentMethod(id));

    trackPaymentMethodClick({ paymentInitSource, paymentMethodType: type, packageId });
  }, [dispatch, id, type, paymentInitSource, packageId]);

  return (
    <MethodWrapper selected={isSelected} onClick={handleClick}>
      {children}
    </MethodWrapper>
  );
};
